module.exports = __webpack_public_path__ + "img/6-0-0.d82916b8.png";